import { parseNullableValue } from '@clearverify/utils';

import { DashboardPlatformAdminTopVerifierDataInfoFragment } from 'src/api';
import { insertLinebreaks } from 'src/utils/string';

export const prepareDataset = (
  topVerifiersData: DashboardPlatformAdminTopVerifierDataInfoFragment[],
) => {
  return topVerifiersData.map(item => ({
    displayName: insertLinebreaks(parseNullableValue(item.displayName), 45, 3),
    count: item.verificationRequestsCount,
  }));
};
